var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asset-header" }, [
    _c(
      "div",
      { staticClass: "asset-header__chips" },
      _vm._l(_vm.chips, function(chip) {
        return _c(
          "v-tooltip",
          {
            key: chip.key,
            attrs: { bottom: "", "open-delay": "300" },
            scopedSlots: _vm._u(
              [
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    var attrs = ref.attrs
                    return [
                      _c(
                        "span",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "asset-header__chip",
                              class: {
                                "asset-header__chip--truncado": chip.truncar
                              },
                              style: chip.estilo
                            },
                            "span",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [_vm._v(" " + _vm._s(chip.texto) + " ")]
                      )
                    ]
                  }
                }
              ],
              null,
              true
            )
          },
          [_c("span", [_vm._v(_vm._s(chip.dica))])]
        )
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }